var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagHu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 140 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26626_59484)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.13 30.8101H0.5V61.6201H139.13V30.8101Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.13 0H0.5V30.81H139.13V0Z",
    fill: "#D01317"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.13 61.61H0.5V92.42H139.13V61.61Z",
    fill: "#52AB32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26626_59484"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 138.63,
    height: 92.42,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagHu);
export default __webpack_public_path__ + "static/media/Flag_HU.1dd5bf5bba99a1e0cbcb7d809e6d3c1a.svg";
export { ForwardRef as ReactComponent };